export default "__VITE_ASSET__6ff54199__"